import Loader from "react-loader-spinner";
import { useDispatch } from "react-redux";
import { Accordion, Card } from "react-bootstrap";
import { Fragment, useRef, useState } from "react";
import { CheckLg, GearWideConnected } from "react-bootstrap-icons";
import { saveSystemSettings } from "../../store/api/SystemSettingsAPI";

const OtherSettings = (props) => {
    const { findSetting, findCheckedSetting } = props;
    const [pending, setPending] = useState(false);
    const settingValues = useRef({});
    const dispatch = useDispatch()
    const save = () => {
        setPending(true);
        dispatch(saveSystemSettings(settingValues.current, () => { setPending(false) }));
    }
    return (<Fragment>

        <div className="row" style={{ fontSize: "12px" }}>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_AddInvoice")}
                    onChange={e => settingValues.current.LogEvents_AddInvoice = e.target.checked} />&nbsp;
                <span>صدور فاکتور های انبار در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_EditInvoice")}
                    onChange={e => settingValues.current.LogEvents_EditInvoice = e.target.checked} />&nbsp;
                <span>ویرایش فاکتور های انبار در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_DeleteInvoice")}
                    onChange={e => settingValues.current.LogEvents_DeleteInvoice = e.target.checked} />&nbsp;
                <span>حذف فاکتور های انبار در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_AddService")}
                    onChange={e => settingValues.current.LogEvents_AddService = e.target.checked} />&nbsp;
                <span>ایجاد سرویس ها در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_EditService")}
                    onChange={e => settingValues.current.LogEvents_EditService = e.target.checked} />&nbsp;
                <span>ویرایش سرویس ها در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_DeleteService")}
                    onChange={e => settingValues.current.LogEvents_DeleteService = e.target.checked} />&nbsp;
                <span>حذف سرویس ها در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_AddChequeFunction")}
                    onChange={e => settingValues.current.LogEvents_AddChequeFunction = e.target.checked} />&nbsp;
                <span>ایجاد عملیات چک در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_EditChequeFunction")}
                    onChange={e => settingValues.current.LogEvents_EditChequeFunction = e.target.checked} />&nbsp;
                <span>ویرایش عملیات چک در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("LogEvents_DeleteChequeFunction")}
                    onChange={e => settingValues.current.LogEvents_EditChequeFunction = e.target.checked} />&nbsp;
                <span>حذف عملیات چک در رویدادهای مشتری ثبت شود.</span>&nbsp;
            </div>
            {/* <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("SaveSMSEvents")}
                    onChange={e => settingValues.current.SaveSMSEvents = e.target.checked} />&nbsp;
                <span>ثبت رویداد ارسال پیامک</span>&nbsp;
            </div> */}
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("NationalCodeIsRequired")}
                    onChange={e => settingValues.current.NationalCodeIsRequired = e.target.checked} />&nbsp;
                <span>شماره ملی در ویرایش و ایجاد مشتریان الزامی باشد</span>&nbsp;
            </div>
            <div className="form-group col-md-3">
                <input type="checkbox" className="form-check-input" defaultChecked={findCheckedSetting("ShowCloseDeadlineServiceList")}
                    onChange={e => settingValues.current.ShowCloseDeadlineServiceList = e.target.checked} />&nbsp;
                <span>نمایش لیست سرویس هایی که تا تاریخ موعد آنها</span>&nbsp;
                <input type="number" style={{ width: "40px", height: "22px" }}
                    defaultValue={findSetting("ServiceListDeadlineDistance")}
                    onChange={e => settingValues.current.ServiceListDeadlineDistance = e.target.value} />&nbsp;
                <span>روز مانده است</span>
            </div>
            <div className="row"                                                                                                                                     >
                <div className="form-group col-md-2">
                    <label>پیشوند شماره گذاری نامه های اداری</label>
                    <input type="text" className="form-control"
                        defaultValue={findSetting("Letters_PreNumber")}
                        onChange={e => settingValues.current.Letters_PreNumber = e.target.value} />
                </div>
                <div className="form-group col-md-2">
                    <label>پسوند شماره گذاری نامه های اداری</label>
                    <input type="text" className="form-control"
                        defaultValue={findSetting("Letters_PostNumber")}
                        onChange={e => settingValues.current.Letters_PostNumber = e.target.value} />
                </div>
                <div className="form-group col-md-2">
                    <label>شماره آغازین نامه های اداری</label>
                    <input type="text" className="form-control"
                        defaultValue={findSetting("Letters_NumberFrom")}
                        onChange={e => settingValues.current.Letters_NumberFrom = e.target.value} />
                </div>
                <div className="form-group col-md-2">
                    <label>جداکننده شماره نامه های اداری</label>
                    <input type="text" className="form-control"
                        defaultValue={findSetting("Letters_Separator")}
                        onChange={e => settingValues.current.Letters_Separator = e.target.value} />
                </div>
                <div className="form-group col-md-3">
                    <label>ماهیت پیش فرض طرف حساب در پنجره انتخاب</label>
                    <select name="DefaultAccTypeInCustomerSelect" onChange={e => settingValues.current.DefaultAccTypeInCustomerSelect = e.target.value} defaultValue={findSetting("DefaultAccTypeInCustomerSelect")} className="form-control">
                        <option value="">انتخاب کنید</option>
                        <option value="default">پیش فرض سیستم</option>
                        <option value={true}>بدهکار </option>
                        <option value={false}>بستانکار </option>
                    </select>
                </div>
            </div>
        </div>
        <button className="mt-2 btn btn-success group-Btn" onClick={save} disabled={pending}>{pending === true && <Loader type="BallTriangle" color="white" style={{ display: "inline-block" }} width={20} height={20} />}{!pending && <Fragment><CheckLg size={12} /> &nbsp;ذخیره تغییرات</Fragment>}</button>
    </Fragment>)

}
export default OtherSettings;